<template>
  <div class="view-wrap">
    <modal ref="modal" :closeable="true" size="xl" labelID="modal-title">
      <div class="inner-modal">
        <h3 class="text-center" id="modal-title">Change Plan</h3>
        <div class="form-row row-flex">
          <plan-box
            :showPrices="showPrices"
            @clicked="changePlan($event)"
            :pricingValues="pricingValues"
            productName="MONTHLY_PAYMENT"
            :selectedProduct="selectedProduct"
            :sale="sale"
            :isButton="true"
            :showCoupon="showCoupon"
            :card="true"></plan-box>
          <plan-box
            :showPrices="showPrices"
            @clicked="changePlan($event)"
            :pricingValues="pricingValues"
            productName="YEARLY_PAYMENT_RECURRING"
            :selectedProduct="selectedProduct"
            :sale="sale"
            :isButton="true"
            :ribbon="true"
            :showCoupon="showCoupon"
            :card="true"></plan-box>
        </div>
        <div v-if="planChanged" class="change-success">
          <p class="text-center">Plan changed</p>
          <div class="checkmark"></div>
        </div>
        <button v-else class="plain link center keep" @click="changePlan(plan)">Keep current plan</button>
      </div>
    </modal>
    <notices></notices>
    <div class="view-content">
      <section class="custom-padding">
        <div class="section-inner">
          <div class="top-text">
            <h1 v-if="showCoupon">Get TunnelBear at the lowest price of the year</h1>
            <h1 v-else>Get an unlimited TunnelBear&nbsp;plan</h1>
            <p>Includes all TunnelBear apps, priority customer support, and unlimited&nbsp;data.</p>
          </div>
          <div v-if="!preSelected && !mktTest" class="plans-wrap container">
            <plan-box
              :showPrices="showPrices"
              class="order-sm three"
              @clicked="changePlan($event)"
              :pricingValues="pricingValues"
              productName="MONTHLY_PAYMENT"
              :selectedProduct="selectedProduct"
              :sale="sale"
              :isButton="true"
              :showCoupon="showCoupon"></plan-box>
            <!-- Remove after sale is over -->
            <template v-if="sale.isLive">
              <plan-box
                :showPrices="showPrices"
                class="order-sm two"
                @clicked="changePlan($event)"
                :pricingValues="pricingValues"
                productName="YEARLY_PAYMENT_RECURRING"
                :selectedProduct="selectedProduct"
                :sale="sale"
                :ribbon="true"
                ribbonText="SPRING SALE!"
                :isButton="true"
                :showCoupon="showCoupon">
                <img v-if="showSaleDecor && sale.name === 'summer-sale'"
                  class="sale-img"
                  src="./images/yearly-summer-sale-beach-ball.svg"
                  alt="spring-sale">
              </plan-box>
              <plan-box
                :showPrices="showPrices"
                class="order-sm one"
                @clicked="changePlan($event)"
                :pricingValues="pricingValues"
                productName="THREE_YEAR_PAYMENT"
                :selectedProduct="selectedProduct"
                :sale="sale"
                :isButton="true"
                :showCoupon="showCoupon"></plan-box>
            </template>
            <!-- end -->
            <template v-else>
              <plan-box
                :showPrices="showPrices"
                class="order-sm two"
                @clicked="changePlan($event)"
                :pricingValues="pricingValues"
                productName="YEARLY_PAYMENT_RECURRING"
                :selectedProduct="selectedProduct"
                :sale="sale"
                :isButton="true"
                :ribbon="true"
                :showCoupon="showCoupon"></plan-box>
              <plan-box
                :showPrices="showPrices"
                class="order-sm one"
                @clicked="changePlan($event)"
                :pricingValues="pricingValues"
                productName="THREE_YEAR_PAYMENT"
                :selectedProduct="selectedProduct"
                :sale="sale"
                :isButton="true"
                :showCoupon="showCoupon"></plan-box>
            </template>
          </div>
          <div class="payment-content container">
            <div class="pay">
              <div class="inner-container">
                <div class="form-area">
                  <div v-if="preSelected" class="form-row">
                    <plan-box
                      :pricingValues="pricingValues"
                      :showPrices="showPrices"
                      :pricing="pricing"
                      :productName="selectedProduct"
                      :selectedProduct="selectedProduct"
                      :sale="sale"
                      :showCoupon="showCoupon"
                      :card="true"
                      :ribbon="true"
                      :single="true">
                      <img v-if="!sale.isLive" class="plan-img" src="./images/honey.svg" alt="">
                    </plan-box>
                    <button
                      @click="openModal"
                      v-if="(selectedProduct === 'YEARLY_PAYMENT_RECURRING' || selectedProduct === 'MONTHLY_PAYMENT')
                        && !showCoupon
                        && preSelected"
                      class="plain link right change">Change plan</button>
                  </div>
                  <div v-else-if="mktTest" class="plans-wrap mktTest">
                    <plan-box
                      :pricingValues="pricingValues"
                      :showPrices="showPrices"
                      class="order-sm two"
                      @clicked="changePlan($event)"
                      :pricing="pricing"
                      productName="YEARLY_PAYMENT_RECURRING"
                      :selectedProduct="selectedProduct"
                      :sale="sale"
                      :ribbon="true"
                      :isButton="true"
                      :showCoupon="showCoupon"></plan-box>
                    <plan-box
                      v-if="mktTest"
                      :pricingValues="pricingValues"
                      :showPrices="showPrices"
                      class="order-sm one"
                      @clicked="changePlan($event)"
                      :pricing="pricing"
                      productName="TWO_YEAR_PAYMENT"
                      :selectedProduct="selectedProduct"
                      :sale="sale"
                      :ribbon="true"
                      :isButton="true"
                      :showCoupon="showCoupon"></plan-box>
                  </div>
                  <h2 class="h4">Payment Details</h2>
                  <payment-charge :showPrices="showPrices" :modal="requiresAuth" :config="paymentConfig" :pricing="pricing" :pricingValues="pricingValues" @chargeResponse="payResponse"></payment-charge>
                </div>
              </div>
            </div>
            <div class="sidebar" :inert="modalOpen">
              <div class="box-wrap">
                <div class="info-box inner-container" :class="{ sale: sale.isLive, giant: selectedProduct === 'MONTHLY_PAYMENT' }">
                  <div class="copy">
                    <img v-show="selectedProduct === 'MONTHLY_PAYMENT'"
                      class="animate"
                      src="./images/monthly-bear.svg"
                      alt=""
                      data-cy="img--monthly-bear">
                    <img v-show="selectedProduct === 'TWO_YEAR_PAYMENT'"
                      src="./images/two-year-bear.svg"
                      alt=""
                      data-cy="img--double-bear">
                    <div v-show="selectedProduct !== 'MONTHLY_PAYMENT' && selectedProduct !== 'TWO_YEAR_PAYMENT'">
                      <div v-if="showSaleDecor && selectedProduct === 'YEARLY_PAYMENT_RECURRING'">
                        <img v-if="sale.name === 'fall-sale'"
                          class="animate"
                          srcset="./images/fall-bear@2x.png 2x, ./images/fall-bear.png 1x"
                          src="./images/fall-bear.png"
                          alt="Save 67%">
                        <img v-else-if="sale.name === 'spring-sale'"
                          class="animate"
                          src="./images/yearly-spring-sale-bear.svg"
                          alt="Save 67%">
                        <img v-else-if="sale.name === 'winter-sale'"
                          class="animate"
                          src="./images/yearly-winter-sale-bear.svg"
                          alt="Save 67%">
                        <img v-else-if="sale.name === 'summer-sale'"
                          class="animate"
                          src="./images/yearly-summer-sale-bear.svg"
                          alt="Save 58%">
                        <img v-else
                          class="animate sale"
                          src="@/../static/images/sale/yearly_holiday@2x.png"
                          alt=""
                          data-cy="img--sale-bear">
                      </div>
                      <img v-else
                        class="animate wtf"
                        src="./images/yearly-bear.svg"
                        alt=""
                        data-cy="img--unlimited-bear">
                    </div>
                    <h4>What you get with your TunnelBear plan</h4>
                    <ul class="check-list">
                      <li>
                        Unlimited data&nbsp;
                        <tooltip>Browse the web without worrying about restrictions to your VPN data.</tooltip>
                      </li>
                      <li>
                        Unlimited devices&nbsp;
                        <tooltip>No limit to the number of devices that you use with your TunnelBear account.</tooltip>
                      </li>
                       <li>
                        Access to over 8000 VPN servers&nbsp;
                        <tooltip>Use VPN servers worldwide, physically located in the country you select.</tooltip>
                      </li>
                      <li>
                        The best and latest VPN tech&nbsp;
                        <tooltip>Support for protocols like WireGuard, and robust anti-censorship technologies sourced by researchers worldwide.</tooltip>
                      </li>
                      <li>
                        Core VPN features&nbsp;
                        <tooltip>Split tunneling, VPN kill switch, protocol selection, network obfuscation, and more.</tooltip>
                      </li>
                      <li>
                        City-level server selection&nbsp;
                        <tooltip>Even more control over where you connect to, with 16 unique cities to choose from in the US and Canada.</tooltip>
                      </li>
                      <li>
                        {{tunnels.length}} countries worldwide&nbsp;
                        <tooltip>Choose from {{tunnels.length}} locations to connect to with servers physically located in the country you select.</tooltip>
                      </li>
                      <li>
                        Publicly audited apps&nbsp;
                        <tooltip>Use the first ever consumer-grade VPN to be publicly audited by an independent security firm.</tooltip>
                      </li>
                      <li>
                        Best-in-class 256-bit AES encryption&nbsp;
                        <tooltip>Secure your internet connection with extremely strong 256-bit symmetric encryption.</tooltip>
                      </li>
                      <li class="apps-li">
                        Apps for <img class="apps" src="./images/apps-list.svg" alt="Mac, Windows, iOS, Android" aria-label="Mac, Windows, iOS, Android">&nbsp;
                        <tooltip>Available for Windows, macOS, iOS, Android, Chrome and Firefox; with limited Linux support.</tooltip>
                      </li>
                    </ul>
                  </div>
                </div>
                <div v-if="products[selectedProduct].includes.indexOf('remembear') > -1" class="additional">
                  <img src="./images/remembear-app.svg" alt="RememBear logo">
                  <div>
                    <p><strong>RememBear Password Manager</strong></p>
                    <p class="small">The RememBear app generates, stores, and autofills your passwords to help keep your accounts secure.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="details" class="bg-regular">
        <div class="section-inner">
          <div class="container">
            <wirecutter v-if="mktTest"></wirecutter>
            <template v-else>
              <h2 class="text-center">Frequently Asked Questions</h2>
              <ul class="faq">
                <li>
                  <list-item>
                    <template slot="title">What is TunnelBear and why do I need&nbsp;it?</template>
                    <template slot="content">
                      <p>TunnelBear is a virtual private network (or VPN for short).</p>
                      <p>When you turn it on, all your device's incoming and outgoing data gets routed through a secure server which protects it with Grizzly-grade encryption.</p>
                      <p>That means when an internet service provider, network owner, or even hacker tries to snoop on your browsing activity, all they'll see is garbled, unreadable junk.</p>
                      <p>This process also changes your IP address to stop anyone online from seeing your real physical location or tying your activity back to you directly.</p>
                    </template>
                  </list-item>
                </li>
                <li>
                  <list-item>
                    <template slot="title">How many devices can I use with my TunnelBear account?</template>
                    <template slot="content">
                      <p>There is no limit on the number of devices you can use with TunnelBear. Simply visit <router-link :to="{name: 'download'}">tunnelbear.com/download</router-link> on each device to install the TunnelBear app. Once the app is installed on your new device, log in with your existing TunnelBear account and connect to a server.</p>
                    </template>
                  </list-item>
                </li>
                <li>
                  <list-item>
                    <template slot="title">What devices are compatible with TunnelBear?</template>
                    <template slot="content">
                      <p>TunnelBear is available for iOS, Android, macOS and Windows, with limited support for Linux.</p>
                    </template>
                  </list-item>
                </li>
                <li>
                  <list-item>
                    <template slot="title">What's your cancellation policy? Do you have a free trial?</template>
                    <template slot="content">
                      <p>TunnelBear may offer refunds on a case-by-case basis. If you are unsatisfied with your purchase for any reason, you can request a refund by contacting our friendly Support Bears.</p>
                      <p>TunnelBear does offer a free trial, but it’s limited to only 500 MB of data per month. Sign up for the unlimited plan to get the best possible experience; however, if you still want to try TunnelBear before you buy it, you can get your free trial <router-link :to="{name: 'pricing'}">over here</router-link>.</p>
                    </template>
                  </list-item>
                </li>
              </ul>
            </template>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>

import paymentCharge from '@/components/payment-charge/payment-charge'
import services from '@/services/services.js'
import notices from '@/components/notices/notices'
import planBox from '@/components/plan-box/plan-box'
import modal from '@/components/modal/modal'
import wirecutter from '@/components/wirecutter/wirecutter'
import zendeskWidget from '@/mixins/zendesk-widget.js'
import products from '@/data/product-details.js'
import listItem from '@/components/list-item/list-item'
import tooltip from '@/components/tooltip/tooltip'
import saleDetails from '@/data/sale-details.js'

export default {
  name: 'pay',
  components: {
    'payment-charge': paymentCharge,
    notices,
    modal,
    'plan-box': planBox,
    wirecutter,
    'list-item': listItem,
    tooltip
  },
  mixins: [zendeskWidget],
  data () {
    return {
      mktTest: this.$route.path.indexOf('-a') > -1,
      selectedProduct: this.$route.path.indexOf('-a') > -1 ? 'TWO_YEAR_PAYMENT' : this.$route.query?.term === 'monthly' ? 'MONTHLY_PAYMENT' : 'YEARLY_PAYMENT_RECURRING',
      couponCode: this.$route.query.couponCode || '',
      preSelected: this.$route.query.bearType || this.$route.query.plan || '',
      planChanged: false,
      paymentSuccess: false,
      products
    }
  },
  beforeMount: function () {
    this.setProduct()
    // ADDED FOR SALE
    this.$emit('modifyLayout', {
      hideCtaButton: true
    })
    // ADDED FOR SALE ^^
  },
  computed: {
    modalOpen: function () {
      return this.$store.getters.modalOpen
    },
    paymentConfig: function () {
      const data = {
        productName: this.selectedProduct
      }
      if (this.products[this.selectedProduct].endpointOverride) {
        data.endpoint = this.products[this.selectedProduct].endpointOverride
      }
      return data
    },
    sale: function () {
      return this.$store.state.pricingService.sale
    },
    requiresAuth: function () {
      return !this.$route.meta.requiresAuth
    },
    pricing: function () {
      return this.$store.state.pricingService.couponPricing || this.$store.state.pricingService.pricing
    },
    pricingValues: function () {
      return this.$store.state.pricingService.couponValues || this.$store.state.pricingService.values
    },
    coupon: function () {
      return this.pricing[this.selectedProduct].coupon || null
    },
    showCoupon: function () {
      return this.coupon &&
             Number(this.pricingValues[this.selectedProduct].chargePrice) === Number(this.coupon.amount)
    },
    isCouponProduct: function () {
      return !!this.coupon && (this.sale.couponProducts[this.coupon.code] === this.selectedProduct)
    },
    showSaleDecor: function () {
      return this.sale.isLive
      // const urlCoupon = this.$route.query.couponCode
      // return (
      //   this.sale.isLive &&
      //   urlCoupon &&
      //   this.sale.couponProducts[urlCoupon]
      // )
    },
    showPrices: function () {
      if (this.couponCode) {
        return this.$store.state.pricingService.couponRequested
      } else {
        return true
      }
    }
  },
  created: async function () {
    this.$store.state.locationService.isSanctioned().then(isSanctioned => {
      if (isSanctioned) {
        this.$router.replace({ name: 'pricing' })
      }
    })
    this.$store.state.locationService.getCountryCode().then(isoCountry => {
      if (isoCountry === 'IN') {
        this.$router.replace({ name: 'pricing' })
      }
    })

    this.$emit('modifyLayout', {
      hideCtaButton: true,
      minimalNav: true,
      minimalFooter: true
    })

    this.$store.state.pricingService.getPricingData()
    if (this.couponCode) this.$store.state.pricingService.getCouponPricing(this.couponCode)
    services.pushMktDataLayer()
  },
  methods: {
    setProduct: function () {
      if (this.preSelected) {
        for (const product in this.products) {
          if (this.products[product].query.indexOf(this.preSelected) > -1) {
            this.selectedProduct = product
          }
        }
      }
    },
    payResponse: function (result) {
      if (result === 'PASS') {
        this.paymentSuccess = true
        this.$store.dispatch('getBillingData', true)
        if (this.$route.path === '/account/purchase') {
          let price
          if (this.pricing[this.selectedProduct].chargePrice) {
            price = Number(this.pricing[this.selectedProduct].chargePrice).toFixed(2)
          }
        } else {
          const accountType = this.selectedProduct === 'MONTHLY_PAYMENT' ? 'giant' : 'grizzly'
          this.$router.push({ name: 'account-upgraded', query: { bearType: accountType } })
        }
      }
    },
    openModal: function () {
      this.$refs.modal.openModal()
      this.planChanged = false
    },
    changePlan: function (selected) {
      if (selected === this.selectedProduct) {
        this.$refs.modal.closeModal()
        return
      }
      this.selectedProduct = selected
      this.planChanged = true
      setTimeout(() => {
        this.$refs.modal.closeModal()
      }, 800)
    }
  }
}
</script>

<style scoped lang="stylus" src="./pay.styl" >
